import { render, staticRenderFns } from "./ItemAddToCartDialog.vue?vue&type=template&id=0bb0d9fb&scoped=true"
import script from "./ItemAddToCartDialog.vue?vue&type=script&lang=ts"
export * from "./ItemAddToCartDialog.vue?vue&type=script&lang=ts"
import style0 from "./ItemAddToCartDialog.vue?vue&type=style&index=0&id=0bb0d9fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb0d9fb",
  null
  
)

export default component.exports